export default "//static.tradera.net/touchweb/static/output/images/category-books-magazines.7fd56e26.svg";